import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown";
import SimpleTooltip from "@rio-cloud/rio-uikit/SimpleTooltip";

export type SharedDummyRowDropdownItem = {
  title: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
};

export interface SharedDummyRowDropdownProps {
  items: SharedDummyRowDropdownItem[];
  usePortal?: boolean;
}

const renderItemButton = (item: SharedDummyRowDropdownItem) => (
  <button
    type="button"
    className="btn btn-link display-flex align-items-center justify-content-start gap-10 width-200 padding-0 text-decoration-none text-left"
    onClick={item?.onClick}
    disabled={item?.disabled}
  >
    <span className={`${item?.icon} text-color-highlight `} />
    <span>{item?.title}</span>
  </button>
);

const renderItemValue = (item: SharedDummyRowDropdownItem) => {
  const button = renderItemButton(item);

  if (!item?.disabled || !item?.disabledTooltip) return button;

  return (
    <SimpleTooltip content={item.disabledTooltip} placement="left" width={250} textAlignment="left">
      <span className="display-block">{button}</span>
    </SimpleTooltip>
  );
};

const SharedDummyRowDropdown = ({ items, usePortal }: SharedDummyRowDropdownProps) => (
  <span>
    <ButtonDropdown
      title={<span className="rioglyph rioglyph-option-vertical" />}
      variant="link"
      iconOnly
      pullRight
      usePortal={usePortal}
      items={items.map((item) => ({ value: renderItemValue(item) }))}
    />
  </span>
);

export default SharedDummyRowDropdown;
